import { useCallback, useEffect, useState } from "react";

import {
  getAlertedProductsPlanOptions,
  getAlertedProductsSuppliersByJourney,
} from "../../../entities/alerted-product";

// Filtros dependientes del buscador de homologación.
//
// - Jornada: NO es editable. Queda fija en la jornada de los items de la
//   solicitud (defaultJourney) y solo se muestra como contexto.
// - Plan y Proveedor: dependen de esa jornada; se cargan y se limpian cada vez
//   que cambia la jornada de la solicitud.
export const useHomologationFilters = ({ isOpen, defaultJourney }) => {
  const selectedJourney = defaultJourney ?? null;

  const [planOptions, setPlanOptions] = useState([]);
  const [planLoading, setPlanLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [supplierOptions, setSupplierOptions] = useState([]);
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  // Plan y proveedor se recargan (y se limpian) según la jornada de la solicitud.
  useEffect(() => {
    setSelectedPlan(null);
    setSelectedSupplier(null);

    const jornadaId = selectedJourney?.value ?? null;
    if (!isOpen || jornadaId == null) {
      setPlanOptions([]);
      setSupplierOptions([]);
      return undefined;
    }

    let cancelled = false;
    setPlanLoading(true);
    setSupplierLoading(true);

    getAlertedProductsPlanOptions(jornadaId)
      .then((options) => {
        if (!cancelled) setPlanOptions(options);
      })
      .catch(() => {
        if (!cancelled) setPlanOptions([]);
      })
      .finally(() => {
        if (!cancelled) setPlanLoading(false);
      });

    getAlertedProductsSuppliersByJourney(jornadaId)
      .then((options) => {
        if (!cancelled) setSupplierOptions(options);
      })
      .catch(() => {
        if (!cancelled) setSupplierOptions([]);
      })
      .finally(() => {
        if (!cancelled) setSupplierLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isOpen, selectedJourney?.value]);

  const changePlan = useCallback((option) => setSelectedPlan(option ?? null), []);
  const changeSupplier = useCallback((option) => setSelectedSupplier(option ?? null), []);

  return {
    selectedJourney,
    planOptions,
    planLoading,
    selectedPlan,
    changePlan,
    supplierOptions,
    supplierLoading,
    selectedSupplier,
    changeSupplier,
  };
};